module.exports = __webpack_public_path__ + "img/PRCA1_TMKI67.c5a99748.png";